//DrConsulta

//Header
export const backgroundHeaderMobile = '#0446C9';
export const backgroundHeader = '#0446C9';
export const widthLogoDesktop = '150px';
export const widthLogoMobile = '110px';

// Form Button
export const colorBtnAddSubscriberBtnBackFormButton = '#0446C9';
export const backgroundBtnFowardFormButton = '#0446C9';
export const borderBtnBackFormButton = '#0446C9';
export const backgroundBtnAddSubscriberFormButton = '#0446C9'; // Adicionar Titular
export const colorBtnAddSubscriberkFormButton = 'white';
export const colorBtnAdvanceFormButton = 'white';
export const backgroundBtnAdvanceFormButton = '#0446C9';
export const borderBtnAdvanceFormButton = '#0446C9';
export const colorBackgroundChecked = '#0446C9';

// Order Resume
export const colorTdOrderResume = '#0446C9';
export const colorH2H4AnchorIconContainerOrderResume = '#0446C9';
export const borderOrderResume = '#0446C9';
export const backgroundApplyButtonOrderResume = '#0446C9';

// StepCounter (progress bar)
export const textSpanTimeLine = '#0446C9';

// Form Wrapper
export const borderTitularDepende = '#0446C9';

// Subscriber Title
export const colorTitleSubscriber = '#0446C9';

// Subscribers list Title
export const colorTitleListSubscribers = '#0446C9';

// Subscribers list
export const colorListSubscribersFaRegEdit = '#0446C9';

// Payment Title
export const colorTitlePayment = '#0446C9';

// Payment Nav-tab
export const backgroundNavActivePayment = '#0446C9';

//Container
export const backgroundContainer = 'none';
